import { Analytics } from '@util/Analytics';
import React, { ReactElement } from 'react';
import { LayoutScreenConfig, ScreenType } from '../../../config/FlowTypes';
import { useAppStore } from '../../../store/Store';
import { dispatchUserData } from '../../../store/userData/UserDataActions';
import { NavigationProps } from '../FlowNavigation';
import {
  CoverageEmployerLayout,
  CoverageEmployerLayoutConfig,
} from '../layouts/CoverageEmployerLayout';

export type CoverageEmployerScreenConfig<ScreenNames extends string> = LayoutScreenConfig<
  ScreenType.CoverageEmployer,
  CoverageEmployerLayoutConfig,
  ScreenNames
>;

type Props<ScreenNames extends string> = NavigationProps<
  CoverageEmployerScreenConfig<ScreenNames>,
  ScreenNames
>;

/**
 * "Who is your employer?", stored under the screen name. The employer-outreach consent is asked on
 * the coverage consents screen, once the user has given all their details.
 */
export const CoverageEmployerScreen = <ScreenNames extends string>(
  props: Props<ScreenNames>
): ReactElement => {
  const prefill = useAppStore((state) => state.userData.coverageUsEmployer?.[0]);

  function onSubmit(employer: string): void {
    dispatchUserData({ [props.screenName]: [employer] });

    // The typed employer name is sent so Customer.io campaigns can use it; work email and address stay out.
    Analytics.track({
      event: Analytics.Event.o_question_answered,
      question: props.screenName,
      answer: employer,
    });

    props.navigation.next(props);
  }

  return (
    <CoverageEmployerLayout {...props.layout} prefill={prefill} onPressPrimaryButton={onSubmit} />
  );
};
